<template>
  <div class="table-wrapper">
    <v-data-table
      :headers="tableHeaders"
      :items="mirrorData"
      class="mirror-table"
      :class="reorderPermission ? 'table-reorder' : 'table-fixed'"
      disable-pagination
      fixed-header
      disable-sort
      hide-default-footer
      :mobile-breakpoint="0"
    >
      <template slot="item" slot-scope="props">
        <tr @click="$emit('openMirrorDetail', props.item)">
          <td class="text-start">{{ props.item.page || emptyField }}</td>
          <td class="text-start">
            <div
              :class="
                textColorClassFromType(
                  'table',
                  normalizeType(props.item.item_type),
                )
              "
            >
              <v-icon>mdi-label</v-icon>
              {{ itemTypeDisplay(normalizeType(props.item.item_type)) }}
            </div>
          </td>
          <td class="text-start">{{ props.item.title || emptyField }}</td>
          <td class="text-start">{{ props.item.reporter || emptyField }}</td>
          <td class="text-start">{{ props.item.editor || emptyField }}</td>
          <td class="text-start">
            {{ formatMetadata(props.item.speaking_time) }}
          </td>
          <td class="text-start">
            {{ formatMetadata(props.item.total_time) }}
          </td>
          <td class="text-start">
            {{ formatMetadata(props.item.start_time, true) }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="snackbarTimeout"
      bottom
      left
    >
      {{ this.feedbackMessage }}
      <v-btn color="primary" text @click="hideSnackbar()">Entendi</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {
  textColorClassFromType,
  itemTypeDisplay,
  normalizeType,
} from '@/utils/mirrorFormatter.js';
import { formatSeconds } from '@/utils/date.js';

export default {
  name: 'MirrorTable',
  props: {
    mirrorData: {
      type: Array,
      required: false,
    },
    reorderPermission: Boolean,
    feedbackMessage: String,
  },
  components: {},
  data() {
    return {
      emptyField: '--',
      snackbarTimeout: 6000,
    };
  },

  computed: {
    snackbar: {
      get() {
        return this.snackbarBox;
      },
      set(value) {
        this.$store.dispatch('news/snackbarTrigger', value);
      },
    },

    tableHeaders() {
      return [
        { text: 'PG', class: 'header-text', value: 'page' },
        { text: 'Tipo', class: 'header-text', value: 'item_type' },
        { text: 'Retranca', class: 'header-text', value: 'title' },
        { text: 'REP', class: 'header-text', value: 'reporter' },
        { text: 'Edi', class: 'header-text', value: 'editor' },
        { text: 'tCAB', class: 'header-text', value: 'speaking_time' },
        { text: 'tMAT', class: 'header-text', value: 'total_time' },
        { text: 'Tempo', class: 'header-text', value: 'program_start' },
      ];
    },
  },

  methods: {
    textColorClassFromType,
    itemTypeDisplay,
    normalizeType,

    hideSnackbar() {
      this.$store.dispatch('news/snackbarTrigger', false);
    },

    formatMetadata(value, includeHours = false) {
      return value ? formatSeconds(value, includeHours) : this.emptyField;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/inputs.scss';
@import '@/assets/scss/mirror-table.scss';

.table-wrapper {
  background-color: $color-background;
  overflow: hidden;
  font-family: 'globotipo' !important;

  .mirror-table-skeleton {
    margin: 88px 0 0 0;
  }

  ::v-deep .v-data-table {
    &.mirror-table {
      min-width: calc(100vw - 440px);
      overflow: auto;
      height: inherit;

      ::-webkit-scrollbar-track {
        background-color: rgba($color-black, 0.02);
      }

      ::-webkit-scrollbar {
        scroll-margin: 0 16px;
        width: 8px;
        height: 8px;
        background-color: rgba($color-black, 0.02);
      }

      ::-webkit-scrollbar-thumb {
        background-color: rgba($color-black, 0.24);
      }

      .v-data-table__wrapper {
        height: inherit;

        @include for-size(desktop-down) {
          height: calc(100vh - 248px);
        }

        table {
          // HEAD
          thead {
            tr {
              th {
                font-size: 0.8em;
                color: $color-black-80;
                letter-spacing: 0.08em;
                box-shadow: inset 0 -2px 0 rgb(0 0 0 / 8%);
              }
            }
          }

          // BODY
          tbody {
            tr {
              background-color: $color-white;
              will-change: background-color;
              transition: background-color 0.4s ease-in-out;
              cursor: pointer;

              &:hover {
                background-color: rgba($color-primary, 0.04);
                will-change: background-color;
                transition: background-color 0.4s ease-in-out;

                td {
                  color: $color-primary;
                  will-change: color;
                  transition: color 0.4s ease-in-out;
                }
              }

              td {
                color: $color-black-80;
                font-size: 0.88em;
                border-bottom: solid 1px $color-black-08;
                will-change: color;
                transition: color 0.4s ease-in-out;
              }
            }
          }
        }
      }
    }
  }
}
</style>
